module.exports = {"title":"This page doesn't exist","content":"<p>Please go back to the <a href='/'>Homepage</a> or use the Navigation.</p>"}


//////////////////
// WEBPACK FOOTER
// ./src/components/Common/Page404/locales/en.json
// module id = 1751
// module chunks = 0